import { __decorate, __metadata } from "tslib";
import { Exclude } from "class-transformer-global-storage";
import { getClassName } from '../../class-name';
let Model = /*#__PURE__*/(() => {
  let Model = class Model {
    constructor() {}
    toString() {
      return getClassName(this);
    }
  };
  Model = __decorate([Exclude(), __metadata("design:paramtypes", [])], Model);
  return Model;
})();
export { Model };
;